import { createStyles, makeStyles } from '@material-ui/core/styles';
export default makeStyles(() => createStyles({
  badgeText: {
    display: 'contents',
    fontWeight: 'bold'
  },
  boldText: {
    fontWeight: 'bold'
  }
}));